import styled from 'styled-components'

const Styled = styled.div`
  .ant-table-wrapper {
    > .ant-spin-nested-loading {
      > .ant-spin-container {
        > .ant-table {
          > .ant-table-container {
            table {
              .ant-table-thead {
                > tr {
                  > th {
                  }
                }
              }

              .ant-table-tbody {
                > tr {
                  > td {
                    &.background-grey {
                      background-color: #dfdfdf;
                    }

                    &.background-blue {
                      background-color: #d8edff;
                    }

                    &.background-yellow {
                      background-color: #fef8cb;
                    }
                  }
                }
              }

              .ant-checkbox-inner::after {
              }
            }
          }
        }
      }
    }
  }
`

export default Styled
